(() => {
  'use strict';

  const DESCRIPTION_SELECTOR = '[data-swan-product-description]';
  const CALCULATOR_SELECTOR = '#m_calculator_content, .m__calculator';
  const GENERIC_CALCULATOR_CLASSES = [
    'swan-calculator-block',
    'swan-calculator-legacy',
    'swan-calculator-grid',
    'swan-calculator-field',
    'swan-calculator-result'
  ];

  const directChildContaining = (container, element) => {
    let current = element;

    while (current?.parentElement && current.parentElement !== container) {
      current = current.parentElement;
    }

    return current?.parentElement === container ? current : null;
  };

  const outerCalculators = (root) => Array.from(root.querySelectorAll(CALCULATOR_SELECTOR))
    .filter((candidate) => !candidate.parentElement?.closest(CALCULATOR_SELECTOR));

  const cleanGenericCalculatorStyling = (root, calculator) => {
    if (root.classList.contains('swan-calculator-block')) {
      GENERIC_CALCULATOR_CLASSES.forEach((className) => root.classList.remove(className));
    }

    const nodes = [calculator, ...calculator.querySelectorAll(`.${GENERIC_CALCULATOR_CLASSES.join(', .')}`)];
    nodes.forEach((node) => {
      GENERIC_CALCULATOR_CLASSES.forEach((className) => node.classList.remove(className));
    });
  };

  const findExistingLayout = (root, calculator) => {
    const suppliedContainer = calculator.closest('.container');
    if (
      suppliedContainer
      && suppliedContainer !== root
      && root.contains(suppliedContainer)
      && suppliedContainer.querySelector('table')
    ) {
      return suppliedContainer;
    }

    let current = calculator.parentElement;
    while (current && current !== root) {
      if (current.querySelector('table') && current.querySelector(CALCULATOR_SELECTOR)) return current;
      current = current.parentElement;
    }

    return null;
  };

  const createLayout = (root, calculator) => {
    const table = root.querySelector('.table-container table, table.m__table, table');
    if (!table) return null;

    const specification = table.closest('.table-container')
      || table.closest('.swan-responsive-table')
      || table;

    let commonParent = calculator.parentElement;
    while (commonParent && commonParent !== root && !commonParent.contains(specification)) {
      commonParent = commonParent.parentElement;
    }
    if (!commonParent?.contains(specification)) commonParent = root;

    const specificationChild = directChildContaining(commonParent, specification);
    const calculatorChild = directChildContaining(commonParent, calculator);
    if (!specificationChild || !calculatorChild || specificationChild === calculatorChild) return null;

    const layout = document.createElement('div');
    const specificationComesFirst = Boolean(
      specificationChild.compareDocumentPosition(calculatorChild) & Node.DOCUMENT_POSITION_FOLLOWING
    );
    const firstChild = specificationComesFirst ? specificationChild : calculatorChild;

    commonParent.insertBefore(layout, firstChild);
    layout.appendChild(specificationChild);
    layout.appendChild(calculatorChild);
    return layout;
  };

  const prepareCalculatorLayout = (root, calculator) => {
    if (calculator.dataset.swanSpecCalculatorReady === 'true') return;

    cleanGenericCalculatorStyling(root, calculator);

    const layout = findExistingLayout(root, calculator) || createLayout(root, calculator);
    if (!layout) return;

    const specificationPane = Array.from(layout.children).find((child) => (
      !child.contains(calculator) && Boolean(child.matches('.table-container, .swan-responsive-table, table') || child.querySelector('table'))
    ));
    const calculatorPane = directChildContaining(layout, calculator);
    if (!specificationPane || !calculatorPane || specificationPane === calculatorPane) return;

    layout.classList.add('swan-product-spec-calculator-layout');
    specificationPane.classList.add('swan-product-specification-pane');
    calculatorPane.classList.add('swan-product-calculator-pane');
    layout.dataset.swanSpecCalculatorReady = 'true';
    calculator.dataset.swanSpecCalculatorReady = 'true';
  };

  const initialize = (scope = document) => {
    const roots = [];
    if (scope.matches?.(DESCRIPTION_SELECTOR)) roots.push(scope);
    scope.querySelectorAll?.(DESCRIPTION_SELECTOR).forEach((root) => roots.push(root));

    roots.forEach((root) => {
      outerCalculators(root).forEach((calculator) => prepareCalculatorLayout(root, calculator));
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
